import tooltip from 'common/utils/tooltip';

class TooltipDesktopController {
  constructor() {
    this.tooltip = tooltip;
  }
}

export default TooltipDesktopController;



// WEBPACK FOOTER //
// ./client/app/components/tooltipDesktop/tooltipDesktop.controller.js